import React from "react";
import InputField from "components/InputField/InputField";
import { FormControl } from "material-ui";
import { RadioGroup } from "material-ui";
import { FormControlLabel } from "material-ui";
import { Radio } from "material-ui";
import FileField from "components/InputField/FileField";
import Select from "react-select";

const labels = {
  title: "Title",
  superhost_ids: "Superhosts",
  // member_ids: 'Members',
};

const NewStudyGroupForm = ({
  group: {
    title,
    superhost_ids,
    show_for_users,
    logo_url,
    // member_ids,
  },
  superhosts,
  // members,
  errors = {},
  onFieldChange,
  onSubmit,
  handleShowChange,
  handleFileChange,
  onIdsChange,
}) => {
  return (
    <div className="container_records">
      <div className="add_webinar add_study_group">
        <h3>Add MedMeeting</h3>
        <div className="add_webinar_bg row">
          <div>
            <img
              src={logo_url}
              alt="profile-image"
              style={{
                width: 160,
                height: 160,
                borderRadius: "50%",
                display: "block",
                margin: "auto",
                objectFit: "cover",
              }}
            />
            <FileField
              className="col s12"
              field_name="avatar"
              onChange={(e) => handleFileChange(e.target.value)}
              label={labels["avatar"]}
              // errors={errors["avatar"]}
            />
          </div>
          <form className="col s12">
            {[{ field_name: "title", value: title }].map((input) => (
              <InputField
                key={input.field_name}
                className="col s12"
                label={labels[input.field_name]}
                field_name={input.field_name}
                onChange={onFieldChange}
                errors={errors[input.field_name]}
                value={input.value}
              />
            ))}
            <Select
              className="col s12"
              placeholder="Select superhosts"
              onChange={onIdsChange}
              errors={errors["superhost_ids"]}
              value={superhost_ids}
              options={superhosts}
              multi={true}
            />
            {errors["superhost_ids"] && (
              <div style={{ color: "red", fontSize: "0.875rem" }}>
                {(errors || []).join(". ")}
              </div>
            )}
            <FormControl
              style={{ marginTop: "16px" }}
              className="wimin-webinar"
            >
              Show for users
              <RadioGroup
                label="Show for users"
                value={show_for_users}
                onChange={(e) => handleShowChange(e.target.value === "true")}
                row
              >
                <FormControlLabel
                  value={true}
                  control={<Radio color="primary" />}
                  label="Yes"
                />
                <FormControlLabel
                  value={false}
                  control={<Radio color="primary" />}
                  label="No"
                />
              </RadioGroup>
            </FormControl>
            <button
              onClick={onSubmit}
              className="button_classic"
              type="button"
              name="button"
            >
              Save
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

NewStudyGroupForm.defaultProps = {};
export default NewStudyGroupForm;



// WEBPACK FOOTER //
// ./src/components/Admin/StudyGroups/NewStudyGroupForm.jsx